
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        followers: Number,
        theme: null
    },
    computed: {
        currentTheme() {
            return /dark/.test(this.$props.theme) ? 1 : 2;
        },
        totalFollowers() {
            return this.followers?.toLocaleString();
        }
    },
    setup(props, {emit}) {
        const onThemeChanged = (e: any) => {
            emit("themeChanged", +e.target.value == 2 ? "light" : "dark");
        };

        const toggleTheme = () => {
            emit("themeChanged", /light/.test(props.theme) ? "dark" : "light");
        };

        return {
            toggleTheme,
            onThemeChanged
        }
    }
})
